const updateMacroStepEvent = (macroStepName, microStepsList) => {
  const ev = new CustomEvent('progress-bar-step-current', {
    bubbles: true,
    composed: true,
    detail: {
      macroStepName,
      microStepsList,
    },
  });
  document.dispatchEvent(ev);
};

const updateMicroStepEvent = currentMicroStep => {
  const ev = new CustomEvent('progress-bar-micro-step-current', {
    bubbles: true,
    composed: true,
    detail: {
      currentMicroStep,
    },
  });
  document.dispatchEvent(ev);
};

const displayProgressBarEvent = displayBar => {
  const ev = new CustomEvent('show-progress-bar', {
    bubbles: true,
    composed: true,
    detail: {
      displayBar,
    },
  });
  document.dispatchEvent(ev);
};

export { displayProgressBarEvent, updateMacroStepEvent, updateMicroStepEvent };
